import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeletionListenerService {

  @Output() deletionListener: EventEmitter<any> = new EventEmitter();

  constructor() {
    this.deletionListener.subscribe(
        (eventObject) => {
            // This listener has to be removed
        }
    );
  }
}
